"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var AtomicResources = /** @class */ (function (_super) {
    __extends(AtomicResources, _super);
    function AtomicResources() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AtomicResources.prototype.componentDidMount = function () {
        var s = document.createElement('script');
        s.type = 'module';
        s.src = 'https://static.cloud.coveo.com/atomic/v2.42/atomic.esm.js';
        document.body.appendChild(s);
        var s2 = document.createElement('script');
        s2.type = 'module';
        s2.src = 'https://static.cloud.coveo.com/atomic/v2.42/headless/headless.js';
        document.body.appendChild(s2);
        var l = document.createElement('link');
        l.rel = 'stylesheet';
        l.href = 'https://static.cloud.coveo.com/atomic/v2.42/themes/coveo.css';
        document.body.appendChild(l);
        // const Fa = document.createElement('script');
        // Fa.type = 'module';
        // Fa.src = 'https://kit.fontawesome.com/f737751420.js';
        // Fa.crossOrigin = 'anonymous';
        // document.body.appendChild(Fa);
        var FA = document.createElement('link');
        FA.rel = 'stylesheet';
        FA.href =
            'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/solid.min.css';
        document.body.appendChild(FA);
    };
    AtomicResources.prototype.render = function () {
        return (0, jsx_runtime_1.jsx)("div", { id: "atomicResources" });
    };
    return AtomicResources;
}(react_1.default.Component));
exports.default = AtomicResources;
//# sourceMappingURL=AtomicResources.js.map